// extracted by mini-css-extract-plugin
export default {"container":"tips_container__hp6OD","solImg":"tips_solImg__pylB7","mapImg":"tips_mapImg__VdOu6","fullText":"tips_fullText__0Meoh"};